/** Readers for code content (or its card), shared by the frame, its card preview and excerpts. */

/** REST-created frames carry `code`; streamed tool frames carry `input`. */
export function codeFrameText(content: Record<string, unknown>): string {
  if (typeof content.code === "string") return content.code;
  const input = content.input;
  if (!input || typeof input !== "object") return "";
  const command = (input as Record<string, unknown>).command;
  return typeof command === "string" ? command : JSON.stringify(input, null, 2);
}

export function codeFrameLanguage(content: Record<string, unknown>): string {
  if (typeof content.language === "string") return content.language;
  return typeof content.tool_name === "string" ? content.tool_name : "text";
}
